import { FitroomViewport } from '@seddi/ui-babylon-fitroom';
import React, { FC } from 'react';
import { HomeProvider } from '../store/homeStore';
import { useInitHome } from './home.hooks';
import * as S from './home.styles';
import { HomeHeatMapLegend } from './homeHeatMapLegend';
import { HomeMenu } from './homeMenu';
import { HomePoses } from './homePoses';
import { HomeVariants } from './homeVariants';
import { HomeWait } from './homeWait';

const Home: FC = () => {
  const { isLoaded, isHeatMap, isWaiting } = useInitHome();
  return isLoaded ? (
    <S.Layout>
      <S.Viewport>
        <FitroomViewport />
        <S.CornerTL>
          <HomeVariants />
        </S.CornerTL>
        <S.CornerTR>
          <HomePoses />
        </S.CornerTR>
        {isWaiting && <HomeWait />}
        {isHeatMap && (
          <S.CornerBL>
            <HomeHeatMapLegend />
          </S.CornerBL>
        )}
      </S.Viewport>
      <HomeMenu />
    </S.Layout>
  ) : null;
};

const Route: FC = () => {
  return (
    <HomeProvider>
      <Home />
    </HomeProvider>
  );
};

export default Route;
